import { useActionless, useAppSelector } from 'redux/hooks'
import { selectTotalMultiSelectedSize } from 'redux/folders/selectors'
import { SET_FOLDER_STATE } from 'redux/folders/actions/types'

import Checkbox from 'components/formElements/Checkbox'

const SelectAllColumnHeader = () => {
  const subfolders = useAppSelector(state => state.folders.rootFolder.subfolders)
  const decks = useAppSelector(state => state.folders.rootFolder.decks)
  const totalSelected = useAppSelector(selectTotalMultiSelectedSize)

  const [setFolderState] = useActionless(SET_FOLDER_STATE)

  const allItems = subfolders.length + decks.length

  const handleToggleAll = () => {
    const toggleAllOff = totalSelected !== allItems

    const newSelectedFolders: Record<number, boolean> = {}
    const newSelectedDecks: Record<number, boolean> = {}

    subfolders.forEach(folder => (newSelectedFolders[folder.id] = toggleAllOff))
    decks.forEach(deck => (newSelectedDecks[deck.id] = toggleAllOff))

    setFolderState({ selectedSubfolders: newSelectedFolders, selectedDecks: newSelectedDecks })
  }

  return <Checkbox checked={allItems === totalSelected} onChange={handleToggleAll} />
}

export default SelectAllColumnHeader
